import { Paper, Stack, Theme, Typography } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { DvsStatusDisplay } from './DvsStatusDisplay';
import { DvsStatusActions } from './DvsStatusActions';
import {
  TDocumentVerificationStatus,
  TDocumentVerificationStatusActions,
  TDvsErrorDetail,
} from './types';

export function DvsStatus({
  status,
  errorDetails,
  onResetStatus,
  onResubmit,
  hideResubmit = false,
}: Readonly<{
  status?: keyof typeof TDocumentVerificationStatus;
  errorDetails?: TDvsErrorDetail[];
  onResetStatus: (status: keyof TDocumentVerificationStatusActions) => void;
  onResubmit?: () => void;
  /**
   * Leaves Re Submit out altogether. Not the same as omitting `onResubmit`, which keeps the button
   * on screen, disabled.
   */
  hideResubmit?: boolean;
}>) {
  // Derive resubmitDisabled from the presence of onResubmit
  const resubmitDisabled = !onResubmit;

  return (
    <Paper
      data-testid="dvs-status"
      sx={{
        backgroundColor: (theme: Theme) => theme.palette.divider,
        padding: tokens.spacingXs,
        paddingBottom: tokens.spacingBase,
        maxWidth: tokens.size2xs,
      }}
    >
      <Typography variant="caption" color="textSecondary">
        DVS Status
      </Typography>
      <Stack gap={tokens.spacingBase} marginTop={tokens.spacingXs}>
        <DvsStatusDisplay status={status} errorDetails={errorDetails} />
        <DvsStatusActions
          resubmitDisabled={resubmitDisabled}
          hideResubmit={hideResubmit}
          onResetStatus={onResetStatus}
          onResubmit={onResubmit || (() => {})}
        />
      </Stack>
    </Paper>
  );
}
